export default __webpack_public_path__ + "static/media/desktop_tc2_En.5110e1ad.webp";